module.exports = __webpack_public_path__ + "static/media/mn.04b0f148.svg";